import type { DesignSystemTheme } from '~/styles/theme'

export const createDevices = (breakpoint: DesignSystemTheme['breakpoint']) => {
  const mobile = `screen and (max-width: ${breakpoint.sm.max})`
  const desktop = `only screen and (min-width: ${breakpoint.md.min})`

  return {
    // Hardcoding this breakpoint to adhere to W3C WCAG 2.1 AA level accessibility requirements
    smallMobile: 'screen and (max-width: 320px)',
    mobile,
    desktop,
    notMobile: desktop,
    notDesktop: mobile,
  }
}

export type Devices = ReturnType<typeof createDevices>

export default createDevices
